import { CSSTransition } from 'react-transition-group';
import * as React from 'react';

const BASE: string = 'animation';

export enum AnimationType {
  NONE = 'none',
  FADE = 'fade',
  SLIDEDOWN = 'slidedown',
  SLIDELEFT = 'slideleft',
  SLIDERIGHT = 'slideright',
  SLIDEUP = 'slideup'
}

interface AnimationComponentProps {
  addChildAnimation: AnimationType;
  removeChildAnimation: AnimationType;
  mountAnimation: AnimationType;
}

interface AnimationClasses {
  appear?: string;
  appearActive?: string;
  enter?: string;
  enterActive?: string;
  exit?: string;
  exitActive?: string;
}

interface AnimationProps {
  appear: boolean;
  classNames: AnimationClasses;
  enter: boolean;
  exit: boolean;
  in: boolean;
  timeout?: number;
}

export const TIME: number = 200;

export const generateAnimation = (mountAnimation: AnimationType, addChildAnimation: AnimationType, removeChildAnimation: AnimationType) => {
  const animationProps: AnimationProps = {
    classNames: {},
    appear: false,
    enter: false,
    exit: false,
    in: true
  };

  if (mountAnimation === AnimationType.NONE && addChildAnimation === AnimationType.NONE && removeChildAnimation === AnimationType.NONE) {
    return animationProps;
  }

  if (mountAnimation !== AnimationType.NONE) {
    animationProps.appear = true;
    animationProps.timeout = TIME;
    animationProps.classNames.appear = `${BASE}-${mountAnimation}-appear`;
    animationProps.classNames.appearActive = `${BASE}-${mountAnimation}-appear-active`;
  }

  if (addChildAnimation !== AnimationType.NONE) {
    animationProps.enter = true;
    animationProps.timeout = TIME;
    animationProps.classNames.enter = `${BASE}-${addChildAnimation}-enter`;
    animationProps.classNames.enterActive = `${BASE}-${addChildAnimation}-enter-active`;
  }

  if (removeChildAnimation !== AnimationType.NONE) {
    animationProps.exit = true;
    animationProps.timeout = TIME;
    animationProps.classNames.exit = `${BASE}-${removeChildAnimation}-leave`;
    animationProps.classNames.exitActive = `${BASE}-${removeChildAnimation}-leave-active`;
  }

  return animationProps;
};

export const Animation: React.FunctionComponent<AnimationComponentProps> = ({
  addChildAnimation = AnimationType.NONE,
  removeChildAnimation = AnimationType.NONE,
  mountAnimation = AnimationType.NONE,
  children
}) => {
  const animationProps: AnimationProps = generateAnimation(mountAnimation, addChildAnimation, removeChildAnimation);

  return <CSSTransition {...animationProps}>{children}</CSSTransition>;
};
